export const SHOW_EDITCARRIERDATA_MODAL = 'SHOW_EDITCARRIERDATA_MODAL';
export const HIDE_EDITCARRIERDATA_MODAL = 'HIDE_EDITCARRIERDATA_MODAL';
export const CHANGE_EDITCARRIERDATA = 'CHANGE_EDITCARRIERDATA';
export const CHANGE_SELECTEDCLIENTID = 'CHANGE_SELECTEDCLIENTID';